
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import ordersalesLogo from "@/assets/ordersales-logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="py-8 border-b border-gray-200 bg-white sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/">
              <img src={ordersalesLogo} alt="OrderSales.AI" className="h-8 md:h-10" />
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-12">
            <NavLinks />
            <div className="flex items-center space-x-6">
              <Button 
                className="wallpaper-btn-outline border-indigo-700 text-indigo-700 hover:bg-indigo-700 hover:text-white hover:border-indigo-700"
              >
                KIRJAUDU
              </Button>
              <Button 
                className="wallpaper-btn bg-indigo-700 text-white hover:bg-indigo-800 border border-indigo-700"
              >
                ALOITA
              </Button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-indigo-700"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </Button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden pt-6 pb-4 animate-fade-in">
            <div className="flex flex-col space-y-4">
              <NavLinksMobile closeMenu={() => setIsMenuOpen(false)} />
              <div className="flex flex-col space-y-4 pt-4 border-t border-gray-200">
                <Button 
                  className="w-full wallpaper-btn-outline border-indigo-700 text-indigo-700 hover:bg-indigo-700 hover:text-white hover:border-indigo-700"
                >
                  KIRJAUDU
                </Button>
                <Button 
                  className="w-full wallpaper-btn bg-indigo-700 text-white hover:bg-indigo-800 border border-indigo-700"
                >
                  ALOITA
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

const NavLinks = () => (
  <div className="flex items-center space-x-10">
    <a href="#features" className="text-indigo-700 hover:text-indigo-500 transition-colors font-wallpaper uppercase tracking-wider text-sm">
      Ominaisuudet
    </a>
    <a href="#benefits" className="text-indigo-700 hover:text-indigo-500 transition-colors font-wallpaper uppercase tracking-wider text-sm">
      Edut
    </a>
    <a href="#pricing" className="text-indigo-700 hover:text-indigo-500 transition-colors font-wallpaper uppercase tracking-wider text-sm">
      Hinnoittelu
    </a>
    <a href="#faq" className="text-indigo-700 hover:text-indigo-500 transition-colors font-wallpaper uppercase tracking-wider text-sm">
      UKK
    </a>
  </div>
);

const NavLinksMobile = ({ closeMenu }: { closeMenu: () => void }) => (
  <>
    <a 
      href="#features" 
      className="text-indigo-700 hover:text-indigo-500 transition-colors px-2 py-3 font-wallpaper uppercase tracking-wider text-sm border-b border-gray-200"
      onClick={closeMenu}
    >
      Ominaisuudet
    </a>
    <a 
      href="#benefits" 
      className="text-indigo-700 hover:text-indigo-500 transition-colors px-2 py-3 font-wallpaper uppercase tracking-wider text-sm border-b border-gray-200"
      onClick={closeMenu}
    >
      Edut
    </a>
    <a 
      href="#pricing" 
      className="text-indigo-700 hover:text-indigo-500 transition-colors px-2 py-3 font-wallpaper uppercase tracking-wider text-sm border-b border-gray-200"
      onClick={closeMenu}
    >
      Hinnoittelu
    </a>
    <a 
      href="#faq" 
      className="text-indigo-700 hover:text-indigo-500 transition-colors px-2 py-3 font-wallpaper uppercase tracking-wider text-sm border-b border-gray-200"
      onClick={closeMenu}
    >
      UKK
    </a>
  </>
);

export default Navbar;
